export default function FormSubmissionProcessingLoader(
    {
        text = 'Please wait while we process your submission ...',
        iconStyles = {fontSize : '50px'},
    }
) {

    return (
        <div className="m-3 text-center">
            <i className="fa fa-spin fa-spinner" style={iconStyles}/>
            <br/>
            <br/>
            {text}
        </div>
    );

}